


















































// vendor
import { defineComponent, computed } from "@vue/composition-api";
// project
import { NodeTemplates } from "@/components.edit/edit-blueprint";
import * as TextUtils from "@/utils/text";
import { RunForm } from "@/components.run/run-form";
// local
import { getProps } from "../../ts/NodeComponent";

export default defineComponent({
	emits:[ "end", "previous" ],
	components:{
		RunForm
	},
	props:getProps<null>(),
	setup(props, context){

		const title = computed(() => TextUtils.pascalToSentenceCase(props.node?.type));
		const message = "Type not supported";

		const onEnd = () => context.emit("end");
		const onBack = () => context.emit("previous");

		return {
			title,
			message,
			onEnd,
			onBack
		};
	}
});



